import Axios from "../../axios-interceptor";
import { dfoFormApiConstants } from "../../constants/AdminApiConstants";

export async function searchDfoReport(data) {
    return Axios.put(dfoFormApiConstants.SEARCH_DFO_FORM, data, {params: {page: 1, size: 10}});
}